import React from 'react'
import OEIInput from './OEIInput';
import { EMPTY } from './Constants';
export default function OEMappingPopover(props) {
  const setKnovioCreationAccountId = (e) => {
    props.setNewData({ ...props.newData, knovioCreationAccountId: e });
    if (/^\d+$/.test(e)) {
      props.setErrors({ ...props.errors, error5: EMPTY })
    }
    else if (e === '') {
      props.setErrors({ ...props.errors, error5: EMPTY })
    } else {
      props.setErrors({ ...props.errors, error5: 'Knovio Account Numbers are made up of numbers only' })
    }
  }
  return (
    <>
      <div className="oe-form-field">
        <label className="oe-form-field__title" >{'system'}</label>
        <select className="oe-form-field__control" value={'Knovio'}>
          <option value={'knovio'}>{'Knovio'}</option>
        </select>
        {props.errors.error1 !== EMPTY ?
          <div className="oe-form-field__error">{props.errors.error4}</div>
          : EMPTY
        }
      </div>
      <OEIInput value={props.newData.knovioCreationAccountId} setValue={setKnovioCreationAccountId} errorMessage={props.errors.error5} newData={props.newData} name='knovioCreationAccountId' label='Knovio Creation Account ID' showError='false'></OEIInput>
    </>
  )
}
